import { ShortCodeContextProvider_cemeteryFragment$data } from '@/hooks/use-short-code-data/__generated__/ShortCodeContextProvider_cemeteryFragment.graphql'
import { displayablePurchasePrices } from '@lifedot/utils'
import { deducePurchasePrice } from '@lifedot/utils'

export type PriceAndSpecsType =
  ShortCodeContextProvider_cemeteryFragment$data['items'][number]['price_and_specs']

export const sortTop3ByCategory = (
  data: PriceAndSpecsType,
  choiceCode: string
) => {
  return data
    .filter((item) => item.category_code === choiceCode)
    .sort((a, b) =>
      (deducePurchasePrice(a) || Infinity) <
      (deducePurchasePrice(b) || Infinity)
        ? -1
        : 1
    )
    .slice(0, 3)
}

export const adjustPriceData = (data: PriceAndSpecsType) => {
  return data.map((priceAndSpec) => {
    const purchasePrice = displayablePurchasePrices(
      priceAndSpec,
      '未掲載',
      'パンフレットにてご確認ください'
    )
    return {
      priceId: priceAndSpec.priceId,
      name: priceAndSpec.name,
      purchasePrice: {
        price: purchasePrice.priceNumber,
        unit: purchasePrice.priceUnit,
        supplement: purchasePrice.priceSupplement,
        managementFee: purchasePrice.managementFee
      }
    }
  })
}

export const getSortedTop3Prices = (
  data: PriceAndSpecsType,
  choiceCode: string
) => {
  const sorted = sortTop3ByCategory(data, choiceCode)
  return adjustPriceData(sorted)
}
